import { $auth } from "@/plugins/auth"
import type { NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded } from "vue-router"
import {ROUTES} from "@/router/paths"
import route from "@/plugins/route"

export default class NotAuthorized implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if ($auth.user && !$auth.user?.is_impersonated) {
      return cancel(route(ROUTES.ACCOUNT_SELECT))
    } else if ($auth.user && $auth.user?.is_impersonated) {
      return cancel(route(ROUTES.CALENDAR))
    }

    // add role checks here

    await next(to, from, cancel)
  }
}
